import { render, staticRenderFns } from "./InquiryFormList.vue?vue&type=template&id=3dc6cc78&scoped=true&"
import script from "./InquiryFormList.vue?vue&type=script&lang=js&"
export * from "./InquiryFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6cc78",
  null
  
)

export default component.exports